module.exports = __webpack_public_path__ + "img/layer-2.a8d21fa5.png";